module.exports = __webpack_public_path__ + "media/theme/itunes__tutorial--4-cf1f08ad.png";